module.exports = __webpack_public_path__ + "img/observatorio.ba829830.jpg";